<template>
  <section>
    <!-- ====================================================== -->
    <!-- ACTIVIDADES -->
    <!-- ====================================================== -->

    <div class="actividades-grid">

      <!-- ACTIVIDAD 1 -->
      <div class="actividad-card">
        <img
          src="../assets/logos/PORTADA1.jpg"
          alt="Campaña Institucional"
          class="actividad-imagen"
          @click="abrirModal(actividad1)"
        />

        <button
          type="button"
          class="actividad-boton"
          @click="abrirModal(actividad1)"
        >
          CAMPAÑA INSTITUCIONAL: LA DIALISIS ES VIDA, DISFRUTA TU VIDA
        </button>
      </div>


      <!-- ACTIVIDAD 2 -->
      <div class="actividad-card">
        <img
          src="../assets/logos/PORTADA2.jpg"
          alt="Somos más que hacer diálisis"
          class="actividad-imagen"
          @click="abrirModal(actividad2)"
        />

        <button
          type="button"
          class="actividad-boton"
          @click="abrirModal(actividad2)"
        >
           Campaña Institucional La Diálisis Es Vida, <br> Disfruta Tu Vida Con Tu Familia 2026 
        </button>
      </div>

    </div>


    <!-- ====================================================== -->
    <!-- MODAL -->
    <!-- ====================================================== -->

    <Transition name="modal-fade">

      <div
        v-if="modalVisible"
        class="modal-overlay"
        @click.self="cerrarModal"
      >

        <div class="modal-contenedor">

          <!-- HEADER -->
          <div class="modal-header">

            <h3 class="modal-header-titulo">
              {{ actividadSeleccionada.tituloModal }}
            </h3>

            <button
              type="button"
              class="modal-cerrar-x"
              aria-label="Cerrar"
              @click="cerrarModal"
            >
              &times;
            </button>

          </div>


          <!-- BODY -->
          <div class="modal-body">

            <!-- ================================================== -->
            <!-- CARRUSEL -->
            <!-- ================================================== -->

            <div class="modal-carousel">

              <button
                v-if="actividadSeleccionada.imagenes.length > 1"
                type="button"
                class="carousel-control anterior"
                aria-label="Imagen anterior"
                @click="anteriorImagen"
              >
                &#10094;
              </button>


              <img
                :src="actividadSeleccionada.imagenes[indiceImagen]"
                :alt="actividadSeleccionada.titulo"
                class="modal-imagen"
              />


              <button
                v-if="actividadSeleccionada.imagenes.length > 1"
                type="button"
                class="carousel-control siguiente"
                aria-label="Imagen siguiente"
                @click="siguienteImagen"
              >
                &#10095;
              </button>

            </div>


            <!-- INDICADORES -->
            <div
              v-if="actividadSeleccionada.imagenes.length > 1"
              class="carousel-indicadores"
            >
              <button
                v-for="(imagen, index) in actividadSeleccionada.imagenes"
                :key="index"
                type="button"
                class="indicador"
                :class="{ activo: indiceImagen === index }"
                @click="indiceImagen = index"
              ></button>
            </div>


            <!-- ================================================== -->
            <!-- TÍTULO -->
            <!-- ================================================== -->

            <h4 class="modal-titulo">
              {{ actividadSeleccionada.titulo }}
            </h4>


            <!-- ================================================== -->
            <!-- DESCRIPCIÓN -->
            <!-- ================================================== -->

            <div class="modal-texto">

              <p>
                {{ actividadSeleccionada.descripcion }}
              </p>

            </div>

          </div>


          <!-- ====================================================== -->
          <!-- FOOTER -->
          <!-- ====================================================== -->

          <div class="modal-footer">

            <button
              type="button"
              class="btn-cerrar"
              @click="cerrarModal"
            >
              Cerrar
            </button>

          </div>

        </div>

      </div>

    </Transition>

  </section>
</template>


<script>
import PORTADA1 from "../assets/logos/PORTADA1.jpg";
import PORTADA2 from "../assets/logos/SANTO-DOMINGO.jpg";

export default {
  name: "AlbumActividades",

  data() {
    return {

      modalVisible: false,

      indiceImagen: 0,

      actividadSeleccionada: {
        titulo: "",
        tituloModal: "",
        descripcion: "",
        imagenes: [],
      },


      // ==========================================================
      // ACTIVIDAD 1
      // ==========================================================

      actividad1: {
        tituloModal: "Campaña Institucional",

        titulo:
          "CAMPAÑA INSTITUCIONAL: LA DIALISIS ES VIDA, DISFRUTA TU VIDA",

        descripcion:
          "La Diálisis Es Vida, Disfruta Tu Vida es una campaña institucional orientada a promover el bienestar, la participación y la calidad de vida de nuestros pacientes.",

        imagenes: [
          PORTADA1,

          // Para agregar más imágenes:
          // require("../assets/logos/otra-imagen.jpg"),
        ],
      },


      // ==========================================================
      // ACTIVIDAD 2
      // ==========================================================

      actividad2: {
        tituloModal: " Campaña Institucional La Diálisis Es Vida, Disfruta Tu Vida Con Tu Familia 2026",

        titulo:
          "Campaña Institucional La Diálisis Es Vida, Disfruta Tu Vida Con Tu Familia 2026",

        descripcion:
          "En mayo se realizó el lanzamiento de la campaña institucional en su primera temática: “LA DIÁLISIS ES VIDA, DISFRUTA TU VIDA CON TU FAMILIA”, procurando la participación a través de la música y el baile de usuarios con sus familiares y/o acompañantes. ",

        imagenes: [
          PORTADA2,

          // Para agregar más imágenes:
          // require("../assets/logos/otra-imagen-2.jpg"),
        ],
      },

    };
  },


  mounted() {
    document.addEventListener("keydown", this.cerrarConEscape);
  },


  beforeUnmount() {
    document.removeEventListener("keydown", this.cerrarConEscape);

    document.body.style.overflow = "";
  },


  methods: {

    abrirModal(actividad) {

      this.actividadSeleccionada = actividad;

      this.indiceImagen = 0;

      this.modalVisible = true;

      // Evita scroll detrás del modal
      document.body.style.overflow = "hidden";
    },


    cerrarModal() {

      this.modalVisible = false;

      this.indiceImagen = 0;

      document.body.style.overflow = "";
    },


    cerrarConEscape(event) {

      if (event.key === "Escape" && this.modalVisible) {
        this.cerrarModal();
      }

    },


    siguienteImagen() {

      const cantidad =
        this.actividadSeleccionada.imagenes.length;

      if (cantidad <= 1) {
        return;
      }

      this.indiceImagen =
        (this.indiceImagen + 1) % cantidad;
    },


    anteriorImagen() {

      const cantidad =
        this.actividadSeleccionada.imagenes.length;

      if (cantidad <= 1) {
        return;
      }

      this.indiceImagen =
        (this.indiceImagen - 1 + cantidad) % cantidad;
    },

  },
};
</script>


<style scoped>

/* ========================================================== */
/* SECCIÓN DE ACTIVIDADES                                     */
/* ========================================================== */

.actividades-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 60px;

  width: 100%;

  padding: 20px 25px 40px;
}


.actividad-card {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
}


.actividad-imagen {
  display: block;

  width: 100%;
  height: 505px;

  object-fit: cover;

  cursor: pointer;

  transition:
    transform 0.25s ease,
    opacity 0.25s ease;
}


.actividad-imagen:hover {
  transform: scale(1.01);
  opacity: 0.95;
}


.actividad-boton {
  margin-top: 35px;

  padding: 8px 20px;

  border: 2px solid #e5e7eb;
  border-radius: 6px;

  background: #ffffff;

  color: #ff6600;

  font-size: 16px;
  font-weight: 700;

  cursor: pointer;

  transition: all 0.2s ease;
}


.actividad-boton:hover {
  background: #ff6600;
  border-color: #ff6600;

  color: #ffffff;
}


/* ========================================================== */
/* FONDO DEL MODAL                                            */
/* ========================================================== */

.modal-overlay {
  position: fixed;

  inset: 0;

  z-index: 99999;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 25px;

  background: rgba(0, 0, 0, 0.72);

  overflow-y: auto;
}


/* ========================================================== */
/* CONTENEDOR                                                 */
/* ========================================================== */

.modal-contenedor {
  position: relative;

  width: 100%;
  max-width: 900px;

  max-height: 92vh;

  display: flex;
  flex-direction: column;

  background: #ffffff;

  border-radius: 8px;

  box-shadow:
    0 20px 60px rgba(0, 0, 0, 0.35);

  overflow: hidden;
}


/* ========================================================== */
/* HEADER                                                     */
/* ========================================================== */

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 18px 22px;

  border-bottom: 1px solid #dee2e6;
}


.modal-header-titulo {
  margin: 0;

  padding-right: 20px;

  color: #444444;

  font-size: 20px;
  font-weight: 600;

  text-align: left;
}


.modal-cerrar-x {
  flex-shrink: 0;

  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;

  background: transparent;

  color: #555555;

  font-size: 36px;
  font-weight: 400;
  line-height: 1;

  cursor: pointer;

  transition:
    color 0.2s ease,
    transform 0.2s ease;
}


.modal-cerrar-x:hover {
  color: #ff6600;

  transform: scale(1.1);
}


/* ========================================================== */
/* BODY                                                       */
/* ========================================================== */

.modal-body {
  padding: 25px;

  overflow-y: auto;
}


/* ========================================================== */
/* CARRUSEL                                                   */
/* ========================================================== */

.modal-carousel {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;

  background: #f4f4f4;

  overflow: hidden;

  border-radius: 5px;
}


.modal-imagen {
  display: block;

  width: 100%;

  max-height: 560px;

  object-fit: contain;
}


/* ========================================================== */
/* CONTROLES DEL CARRUSEL                                     */
/* ========================================================== */

.carousel-control {
  position: absolute;

  top: 50%;

  transform: translateY(-50%);

  z-index: 3;

  width: 45px;
  height: 55px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;

  background: rgba(0, 0, 0, 0.35);

  color: white;

  font-size: 35px;

  cursor: pointer;

  transition: background 0.2s ease;
}


.carousel-control:hover {
  background: rgba(0, 0, 0, 0.65);
}


.carousel-control.anterior {
  left: 10px;
}


.carousel-control.siguiente {
  right: 10px;
}


/* ========================================================== */
/* INDICADORES                                                */
/* ========================================================== */

.carousel-indicadores {
  display: flex;
  justify-content: center;

  gap: 7px;

  margin-top: 12px;
}


.indicador {
  width: 10px;
  height: 10px;

  padding: 0;

  border: none;
  border-radius: 50%;

  background: #bbbbbb;

  cursor: pointer;
}


.indicador.activo {
  background: #ff6600;
}


/* ========================================================== */
/* TÍTULO DEL MODAL                                           */
/* ========================================================== */

.modal-titulo {
  margin-top: 25px;
  margin-bottom: 15px;

  color: #ff6600;

  font-size: 24px;
  font-weight: 700;

  text-align: center;
}


/* ========================================================== */
/* DESCRIPCIÓN                                                */
/* ========================================================== */

.modal-texto {
  color: #444444;

  font-size: 16px;
  line-height: 1.7;

  text-align: justify;
}


/* ========================================================== */
/* FOOTER                                                     */
/* ========================================================== */

.modal-footer {
  display: flex;
  justify-content: flex-end;

  padding: 15px 22px;

  border-top: 1px solid #dee2e6;
}


.btn-cerrar {
  padding: 9px 22px;

  border: none;
  border-radius: 5px;

  background: #6c757d;

  color: #ffffff;

  font-size: 15px;

  cursor: pointer;

  transition: background 0.2s ease;
}


.btn-cerrar:hover {
  background: #545b62;
}


/* ========================================================== */
/* ANIMACIÓN                                                  */
/* ========================================================== */

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}


.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}


.modal-fade-enter-active .modal-contenedor {
  animation: modalEntrada 0.25s ease;
}


@keyframes modalEntrada {

  from {
    opacity: 0;
    transform: translateY(-15px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }

}


/* ========================================================== */
/* RESPONSIVE                                                 */
/* ========================================================== */

@media (max-width: 900px) {

  .actividades-grid {
    grid-template-columns: 1fr;

    gap: 40px;

    padding-left: 15px;
    padding-right: 15px;
  }


  .actividad-imagen {
    height: auto;
  }

}


@media (max-width: 600px) {

  .modal-overlay {
    padding: 10px;
  }


  .modal-contenedor {
    max-height: 95vh;
  }


  .modal-header {
    padding: 12px 15px;
  }


  .modal-header-titulo {
    font-size: 17px;
  }


  .modal-body {
    padding: 15px;
  }


  .modal-titulo {
    font-size: 19px;
  }


  .modal-texto {
    font-size: 14px;
  }


  .carousel-control {
    width: 36px;
    height: 45px;

    font-size: 27px;
  }


  .actividad-boton {
    font-size: 13px;
  }

}

</style>